// @ts-nocheck
//
// Garden header overlay (new_ui): desktop shows page title + search; mobile shows
// logo + profile pill over the immersive garden (#viewport).

import { onAccountButton } from "./account-menu";
import { openCatalogWithSearch } from "./memorial-catalog";

declare const lucide: { createIcons: () => void } | undefined;

let mounted = false;

export function initGardenHeader(): void {
  if (mounted) return;
  const viewport = document.getElementById("viewport");
  if (!viewport) return;

  const header = document.createElement("div");
  header.id = "garden-header";
  header.innerHTML = /* html */ `
    <div class="garden-header__desktop">
      <div class="garden-header__titles">
        <h1 class="garden-header__title">Il Giardino dei Ricordi</h1>
        <p class="garden-header__subtitle">Un luogo sereno dove i nostri amici continuano a vivere</p>
      </div>
      <label class="search-pill">
        <i data-lucide="search"></i>
        <input
          id="garden-search"
          type="search"
          placeholder="Cerca un memoriale…"
          autocomplete="off"
          aria-label="Cerca un memoriale"
        >
      </label>
    </div>
    <div class="garden-header__mobile">
      <div class="garden-header__brand">
        <img src="/logo-mobile.webp" alt="Pethernity" width="38" height="38">
      </div>
      <button type="button" id="garden-profile-pill" class="garden-header__profile-pill">
        <i data-lucide="log-in"></i>
        <span id="garden-profile-label">Accedi</span>
      </button>
    </div>
  `;
  viewport.appendChild(header);

  const input = header.querySelector("#garden-search") as HTMLInputElement | null;
  const submit = () => {
    const q = input?.value.trim();
    if (q) openCatalogWithSearch(q).catch(() => null);
  };
  input?.addEventListener("keydown", (e: KeyboardEvent) => {
    if (e.key === "Enter") {
      e.preventDefault();
      submit();
    }
  });
  input?.addEventListener("search", submit);

  header.querySelector("#garden-profile-pill")?.addEventListener("click", () => {
    onAccountButton().catch(() => null);
  });

  if (typeof lucide !== "undefined") lucide.createIcons();

  mounted = true;
}
